// PDF Archive — Fase 6 (Phase 1G). Cermin `backend/routers/pdf_archive.py`.
//
// ⛔ URL BERKAS SENGAJA NOL DIAMBIL SAAT DAFTAR DIMUAT.
//
// `GET /documents` mengembalikan METADATA saja; tautan berkasnya diminta
// terpisah lewat `/documents/{id}/signed-url`, dan tautan itu berumur 5-15
// menit (STANDAR_UI: bucket private, nol ada permanent public link).
//
// Mengambil 50 tautan sekaligus saat halaman dimuat berarti hampir semuanya
// KEDALUWARSA sebelum ada yang menekannya — pengguna menekan tautan yang
// terlihat normal lalu mendapat galat storage yang nol menyebut sebabnya.
// Karena itu tautannya diminta SAAT DITEKAN, satu per satu.
import { api } from "./api";

export { apiErrorMessage } from "./inventoryApi";

/**
 * Daftar dokumen. Ruas region/store DISARING BACKEND menurut peran pemanggil
 * — parameternya di sini cuma untuk mempersempit, nol untuk melebarkan.
 *
 * ⚠ `status` kosong berarti backend memakai `ACTIVE`. Itu bawaan yang
 * DISENGAJA: dokumen SUPERSEDED terlihat identik dengan yang aktif, dan
 * seseorang yang mencetak PO SUPERSEDED sedang bekerja dari angka lama.
 */
export const listPdfDocuments = (params) => api.get("/pdf/documents", { params });

export const getPdfDocument = (docId) => api.get(`/pdf/documents/${docId}`);

/** Tautan berkas berumur pendek. Diminta SAAT DITEKAN — lihat catatan atas. */
export const getPdfSignedUrl = (docId) =>
  api.get(`/pdf/documents/${docId}/signed-url`);

/**
 * ⚠ `force: true` menandai PDF ACTIVE yang lama jadi SUPERSEDED. Ia bukan
 * "buat ulang kalau perlu" melainkan "gantikan yang berlaku sekarang".
 */
export const generatePdf = (kind, relatedEntityId, force = false) =>
  api.post("/pdf/generate", {
    kind,
    related_entity_id: relatedEntityId,
    force,
  });

// Jenis dokumen yang BENAR-BENAR ADA di database, diukur 30 Agustus 2026
// (543 baris). Dipakai hanya untuk LABEL yang enak dibaca — daftar ini nol
// menyaring apa pun, jadi jenis baru yang muncul di backend tetap tampil
// (dengan kode mentahnya) alih-alih hilang diam-diam dari layar.
export const LABEL_JENIS = {
  PR: "Permintaan Pembelian",
  PO: "Pesanan Pembelian",
  invoice_vendor: "Tagihan Vendor",
  bukti_bayar_vendor: "Bukti Bayar Vendor",
  tanda_terima: "Tanda Terima Barang",
  kwitansi_tanda_jadi: "Kwitansi Tanda Jadi",
};

export const labelJenis = (kode) => LABEL_JENIS[kode] || kode || "—";
